import React from 'react'
import './Portfolio.css'
import IMG1 from '../../assets/portfolio1.png'
import IMG2 from '../../assets/portfolio2.png'
import IMG3 from '../../assets/portfolio4.png'
import IMG4 from '../../assets/portfolio3.png'
import IMG5 from '../../assets/portfolio5.png'

const data =[
{
  id:1,
  image:IMG1,
  title:"Login Page with JSON Web Token (JWT)",
  github: "https://github.com/",
  demo: "https://mernloginauth.netlify.app/"
},
{
  id:1,
  image:IMG2,
  title:"React Three Fibre website",
  github: "",
  demo: "https://reactfibreportfolio.netlify.app"
},
{
  id:1,
  image:IMG3,
  title:"illustrator Star",
  github: "",
  demo: "https://illustratorstar.netlify.app/"
},
{
  id:1,
  image:IMG4,
  title:"Appointment booking app with Twilio API",
  github: "https://github.com/",
  demo: ""
},
{
  id:1,
  image:IMG5,
  title:"Cryto currency",
  github: "https://github.com/",
  demo: ""
},

]
const portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>

      <h2>Portoflio</h2>

      <div className='container portfolio_container'>
       {
        data.map(({id,image,title,github,demo})=>{
        return(
          <article  key={id}className='portfolio_item'>
          <div className='portfolio_item-image'>
            <img src={image} alt='alt'/>
          </div>
          <h3> {title}</h3>
          <div className='portfolio_item-cta'>
          <a href={github} className='btn' > Github</a>
          <a href={demo} className='btn btn-primary'> Live Demo</a>
          </div>
        </article>
        )
})
       }
      </div>


    </section>
  )
}

export default portfolio